module.exports = __webpack_public_path__ + "public/SiteImages/play-store.png?e213163c";